// --- CORRECTED FILE: packages/internal-sdk/src/analytics/useAnalytics.ts ---

import { useCallback } from 'react';
import { analytics as analyticsClient, GlobalContext } from './analyticsClient';
import { useUser } from '@dopomogai/supabase-client/react';
import type { User } from '@dopomogai/supabase-client';

interface EventProperties {
  [key: string]: any;
}

/**
 * A context-aware hook for tracking analytics events.
 * It automatically enriches events with user ID and any global context.
 */
export const useAnalytics = () => {
  const user = useUser();

  const setGlobalContext = useCallback((context: GlobalContext) => {
    analyticsClient.setGlobalContext(context);
  }, []);

  const track = useCallback(
    (eventType: string, properties: EventProperties = {}) => {
      analyticsClient.trackEvent(eventType, properties, user);
    },
    [user]
  );

  /**
   * Identifies the currently authenticated user to merge their anonymous profile.
   * This should be called once after a successful authentication event.
   * It is now argument-less and uses the user from the context.
   */
  const identify = useCallback(() => {
    if (user) {
      analyticsClient.identifyUser(user as User);
    }
  }, [user]);

  return {
    track,
    identify,
    setGlobalContext,
  };
};